/* eslint-disable no-plusplus */
export default () => {
  const ua = navigator.userAgent.toLowerCase(); 
  const urlhash = window.location.hash;
  const isWX = ua.match(/micromessenger/i);
  // console.log('pubsub');
  // console.log(window.sayhiIsWXMiniApp);
  const sayhi = {
    topics: {},
    subUid: -1,
    sub (topic, func) {
      if (!sayhi.topics[topic]) {
        sayhi.topics[topic] = [];
      }
      const token = (++sayhi.subUid).toString();
      sayhi.topics[topic].push({
        token,
        func
      });
      return token;
    },
    pub (topic, args) {
      if (!sayhi.topics[topic]) {
        return false;
      }
      setTimeout(() => {
          const subscribers = sayhi.topics[topic];
          let len = subscribers ? subscribers.length : 0;

          while (len--) {
              subscribers[len].func(topic, args);
          }
      }, 0);
      return true;
    },
    isWX,
    isMY: ua.match(/alipayclient/i),
    isApp: urlhash.indexOf('app') === 2 && !isWX, // 旧的逻辑判断是否跳过微信授权登录
    getIsMobile () {
      const isWindowsPhone = /(?:windows phone)/.test(ua);
      const isSymbian = /(?:symbianos)/.test(ua) || isWindowsPhone;
      const isAndroid = /(?:android)/.test(ua);
      const isFireFox = /(?:firefox)/.test(ua);
      const isTablet = /(?:ipad|playbook)/.test(ua) || (isAndroid && !/(?:mobile)/.test(ua)) || (isFireFox && /(?:tablet)/.test(ua));
      const isPhone = /(?:iphone)/.test(ua) && !isTablet;
      return isPhone || isAndroid || isSymbian || isTablet;
    },
    getOSType () {
      if(/(android)/i.test(ua)) {
        return 'android';
      }
      if(/(iphone|ipad|ipod|ios)/i.test(ua)) {
        return 'ios';
      }
      return 'others';
    },
    isBtgAndroid: false,
    isBtgIos: false,
    isBtgApp: false,
    isBtgWxMiniApp: false,
    isWXMiniApp: window.sayhiIsWXMiniApp
  };
    
  const os = sayhi.getOSType();
  if (os === 'android' && window.btgWebView) {
    sayhi.isBtgAndroid = true;
    sayhi.isBtgApp = true;
    sayhi.sub('onAppCall', (_e, conf) => {
        window.btgWebView.callAppCommon(JSON.stringify(conf)); 
    });
  }
  if (os === 'ios' && window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.btgWebView) {
    sayhi.isBtgIos = true;
    sayhi.isBtgApp = true;
    sayhi.sub('onAppCall', (_e, conf) => {
        window.webkit.messageHandlers.btgWebView.postMessage(JSON.stringify(conf)); 
    });
  }
  if (sayhi.isBtgApp) {
    sayhi.sub('onAppCallShare', (_e, conf) => {
      sayhi.pub('onAppCall', {
          name: 'callShare',
          params: conf,
          callback: conf.success
      });
    });
  }
  window.sayhi = sayhi;    
};
